import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { GroupInfo } from '../../../../models/group-info';

@Component({
  selector: 'txtb-group-paginator',
  templateUrl: './group-paginator.component.html',
  styleUrls: ['./group-paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GroupPaginatorComponent {
  @Input() groupInfo!: GroupInfo;
  @Output() nextElement = new EventEmitter<string>();

  redirectToNextAction(id: string | null): void {
    if (id) {
      this.nextElement.emit(id);
    }
  }
}
